import { Duration } from "date-fns/types";

export const timeRemaining = (
  duration: Duration,
): { days: string; hours: string; minutes: string; seconds: string } => {
  const formatTwoDigits = (value?: number) => String(value ?? 0).padStart(2, "0");

  return {
    days: formatTwoDigits(duration.days),
    hours: formatTwoDigits(duration.hours),
    minutes: formatTwoDigits(duration.minutes),
    seconds: formatTwoDigits(duration.seconds),
  };
};
